import script from "./FooterIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterIndex.vue?vue&type=script&setup=true&lang=js"

import "./FooterIndex.vue?vue&type=style&index=0&id=0e8fc7b0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8fc7b0"]])

export default __exports__